import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
export interface DialogData {
  status: any;
  subjectName: any;
}
@Component({
  selector: 'app-zoom-image',
  templateUrl: './zoom-image.component.html',
  styleUrls: ['./zoom-image.component.css']
})
export class ZoomImageComponent implements OnInit {
  image:any="";
  previewData:any={}
  rotate:number = 0;

  imageZoomedStatus:boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ZoomImageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.previewData=this.data
    // console.log(this.previewData)
  }
  rotateClockwise(){
    if(this.rotate == 4){
      this.rotate = 0
    }else{
      this.rotate = this.rotate +1;
    }
  }

  imageZoom(){
    console.log('image clicked');
    this.imageZoomedStatus = !this.imageZoomedStatus;
  }

}
